module.exports = __webpack_public_path__ + "area_guangdong_dark.44224558.png";